import { render, staticRenderFns } from "./today-adminbonus.vue?vue&type=template&id=8aaa4454&"
import script from "./today-adminbonus.vue?vue&type=script&lang=js&"
export * from "./today-adminbonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports